<div>
  <div *ngIf="!didMatchStart" class="range-placeholder">
    {{ 'kepler.ranking.notStarted' | translate }}
  </div>
  <div class="col s12 range-container" *ngIf="rangeConfig">
    <lms-range [config]="rangeConfig"></lms-range>
  </div>
  <lms-toolbar [options]="toolbarConfig" (clickDownload)="downloadReport()">
    <gl-context-menu medium>
      <gl-button slot="target" icon icon-center="glicon-download"> </gl-button>
      <gl-menu-item
        [text]="'kepler.ranking.rankingExportCurrentList' | translate"
        (click)="downloadReport()"
      ></gl-menu-item>
      <gl-menu-item
        [text]="'kepler.ranking.rankingExportAllList' | translate"
        (click)="downloadReport(true)"
      ></gl-menu-item>
    </gl-context-menu>
  </lms-toolbar>
  <div class="gl-table__container">
    <gl-table
      [id]="playerListId"
      [dataSource]="dataSource"
      [placeholder]="'actions.noResultTable' | translate"
      paginator
      (onDatasourceUpdate)="onDatasourceUpdate($event.detail.dataSource)"
    >
    </gl-table>
  </div>
</div>
